'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
const ShippingPolicyModal = t0 => {
  const $ = _c(15);
  const {
    isOpen,
    setIsOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== setIsOpen) {
    t2 = () => {
      setIsOpen(false);
    };
    $[1] = setIsOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const closeModal = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faXmark} className="text-lg" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== closeModal) {
    t4 = <button type="button" onClick={closeModal} className="absolute -top-4 -right-4 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10" aria-label="Close">{t3}</button>;
    $[4] = closeModal;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="text-lg font-medium mb-6">{"Shipping & Return Policy"}</h2>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h3 className="font-medium mb-2">Shipping</h3>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section>{t6}<p className="text-light leading-relaxed">Shipping is free whenever possible at {process.env.NEXT_PUBLIC_DOMAIN_DISPLAY_NAME || "hivemodern.com"}. We will attempt to ship all merchandise within two business days of purchase unless otherwise specified. Delivery estimates are good faith estimates only. We will not be liable for any loss, damage, cost or expense related to any delay in shipment or delivery. We cannot ship to post office boxes.</p></section>;
    t8 = <h3 className="font-medium mb-2">Returns</h3>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="p-8 overflow-y-auto max-h-[90vh]">{t5}<div className="space-y-6 text-sm">{t7}<section>{t8}<p className="text-light leading-relaxed">Merchandise purchased from {process.env.NEXT_PUBLIC_DOMAIN_DISPLAY_NAME || "hivemodern.com"} may be returned for store credit or exchange only within 30 days of delivery if accompanied by original receipt and in original condition and in original packaging. Returns must be pre-authorized by calling <a href="tel:+15032421967" className="underline hover:text-primary">503 242 1967</a>. Returns received and not pre-authorized will be subject to 20% restocking fee. Non-stock items, special orders, lighting and polycarbonate items are not returnable. Refunds are not issued except in the case of defective merchandise we are unable to replace. Returns should be properly packed and sent at the customer's expense, to: hive 820 nw glisan street portland, or 97209. Actual cost of shipping item to you will not be credited or refunded. Store credit is valid for one year from date of issue. Thereafter, unused credit is forfeited. Claims for defective or damaged items must be filed within 24 hours of delivery. Please inspect your items immediately upon delivery. Claims received after 24 hours of delivery usually cannot be processed.</p></section><section><h3 className="font-medium mb-2">Order Cancellation</h3><p className="text-light leading-relaxed">Orders cancelled after 24 hours may be subject to a minimum 25% or maximum 50% cancellation and restocking fee in addition to any shipping charges incurred.</p></section></div></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== closeModal || $[12] !== isOpen || $[13] !== t4) {
    t10 = <Modal overlayClassName="fixed inset-0 z-[1000] flex items-center justify-center bg-modal-overlay" className="relative bg-white rounded-sm w-full max-w-[600px] max-h-[90vh] mx-4 outline-none overflow-visible" isOpen={isOpen} onRequestClose={closeModal} contentLabel="Shipping & Return Policy">{t4}{t9}</Modal>;
    $[11] = closeModal;
    $[12] = isOpen;
    $[13] = t4;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};
export default ShippingPolicyModal;
function _temp() {
  Modal.setAppElement("#hivenext");
}